import React, { useEffect } from "react";
import { Button, Form } from "antd";
import { FORM_ART, getDrawerdatenRowEdits } from "../Helper/FormItemElement";

export const EvidenzEvAdrDatenEdit = ({
  tabIndex,
  handleFinish,
  editDaten,
  handleDelete,
}) => {
  const [form] = Form.useForm();
  const getEditProps = () => {
    const datenEditProps1 = [
      /* Zugriff auf array  feld: ["txdaten",1] */
      [
        {
          label: "Name:",
          feld: "name",
          place: "Name als Suchbegriff",
          required: "Bitte geben Sie einen Namen ein!",
        },
      ],
      [
        {
          label: "Gruppe:",
          feld: "gruppe",
          place: "Kundengruppe",
          // required: "Bitte geben Sie einen Vornamen ein!",
        },
      ],
      [
        {
          label: "Ort:",
          feld: "ort",
          place: "Ort",
        },
      ],
      [
        {
          label: "Betreuer:",
          feld: "betreuer",
          place: "Name des Betreuers",
        },
      ],
      [
        {
          row: {
            align: "middle",
            justify: "space-between",
            style: { width: "100%" },
          },
          label: "Aktiv",
          feld: "aktiv",
          art: FORM_ART.CHECKBOX,
        },
        {
          label: "Lieferant",
          feld: "islief",
          art: FORM_ART.CHECKBOX,
        },

        {
          label: "Profi Engl.",
          feld: "profienglish",
          art: FORM_ART.CHECKBOX,
        },
      ],
      [
        {
          row: {
            align: "middle",
            justify: "space-between",
            style: { width: "100%" },
          },
          label: "BesuchPlan.",
          feld: "besuchsplanung",
          art: FORM_ART.CHECKBOX,
        },
        {
          label: "PDF Offen",
          feld: "pdfoffen",
          art: FORM_ART.CHECKBOX,
        },
        {
          label: "Kundentreue",
          feld: "kundentreue",
          art: FORM_ART.CHECKBOX,
        },
      ],
      [
        {
          row: {
            align: "middle",
            justify: "space-between",
            style: { width: "100%" },
          },
          label: "Sprache:",
          feld: "sprache",
          art: FORM_ART.NUMBER,
        },
        {
          label: "KundTreuTage:",
          feld: "kundentreuemaxtage",
          art: FORM_ART.NUMBER,
        },
      ],

      [
        {
          label: "UID-Nummer:",
          feld: "atunummer",
        },
      ],
      [
        {
          label: "Konto::",
          feld: "konto",
          art: FORM_ART.NUMBER,
        },
      ],
    ];
    const datenEditProps2 = [[]];
    const datenEditProps3 = [[]];
    const datenEditProps4 = [[]];

    switch (parseInt(tabIndex)) {
      case 2:
        // console.log("Daten tabIndex=2");
        for (let i = 0; i < 50; i++) {
          datenEditProps2[0].push({
            label: `Text ${i}:`,
            feld: ["txdaten", i],
            place: `Text ${i}`,
          });
        }
        return datenEditProps2;
      case 3:
        // console.log("Daten tabIndex=3");
        for (let i = 0; i < 25; i++) {
          datenEditProps3[0].push(
            {
                row: {
                    align: "middle",
                    justify: "space-between",
                    style: { width: "100%" },
                  },
            label: `Betrag ${2*i}:`,
            feld: ["xlidaten", 2*i],
            art: FORM_ART.BETRAG,
          },
          {
            label: `Betrag ${2*i+1}:`,
            feld: ["xlidaten", 2*i+1],
            art: FORM_ART.BETRAG,
          }
        );
        }
        return datenEditProps3;
      case 4:
        // console.log("Daten tabIndex=4");
        for (let i = 0; i < 25; i++) {
          datenEditProps4[0].push(
            { row: {
                align: "middle",
                justify: "space-between",
                style: { width: "100%" },
              },
            label: `Schalter ${2*i}`,
            feld: ["schalter", 2*i],
            art: FORM_ART.CHECKBOX,
          }, {
            label: `Schalter ${2*i+1}`,
            feld: ["schalter", 2*i+1],
            art: FORM_ART.CHECKBOX,
          }
        );
        }
        return datenEditProps4;
      default:
        return datenEditProps1;
    }
  };
  // Betragsfelder ´mit Nachkomma
  useEffect(() => {
    if (parseInt(tabIndex) === 3 && editDaten) {
      editDaten["xlidaten"] = [];
      for (let i = 0; i < 50; i++) {
        editDaten["xlidaten"].push(editDaten.lidaten[i] / 100);
      }
    }
    form.resetFields();
  }, [editDaten, tabIndex]);
  // Zürückrechnen auf int Werte
  const handleFinishControl = (values) => {
    //console.log("handleFinishControl values", values);
    if (parseInt(tabIndex) === 3 && values.xlidaten) {
      values["lidaten"] = [];
      for (let i = 0; i < 50; i++) {
        values.lidaten.push(100 * values.xlidaten[i]);
      }
      delete values.xlidaten;
    }
    handleFinish(values);
  };

  return (
    <>
      <Form
        form={form}
        layout={tabIndex !== 1 ? "horizontal" : "vertical"}
        onFinish={handleFinishControl}
        style={{ margin: 0, padding: 0 }}
        initialValues={editDaten}
      >
        {getDrawerdatenRowEdits(getEditProps())}
        <br />
        <Form.Item key="submit">
          <Button block type="primary" htmlType="submit">
            Speichern
          </Button>
        </Form.Item>
        {tabIndex === 1 && (
          <Form.Item key="delete">
            <Button block danger onClick={handleDelete}>
              Datensatz löschen
            </Button>
          </Form.Item>
        )}
      </Form>
    </>
  );
};
